const OBJECT_URL_REVOKE_DELAY_MS = 10000;

const clickAnchor = (href: string, fileName?: string): void => {
  const anchor = document.createElement('a');
  anchor.href = href;
  anchor.rel = 'noopener';
  if (fileName) anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const saveBlobWithAnchor = (blob: Blob, fileName: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  clickAnchor(objectUrl, fileName);
  setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_REVOKE_DELAY_MS);
};

export const navigateWithAnchor = (url: string): void => clickAnchor(url);
